import { API_BASE_URL } from '../config';
import api from './axiosInstance';

export const getNoClientsPaged = async ({
  page = 1,
  pageSize = 10,
  sortBy = null,
  desc = null,
  search = null,
  etapaNegocio = null,
  motivoCierrePerdido = null,
  startDate = null,
  endDate = null,
  signal,
} = {}) => {
  try {
    const params = { page, pageSize };

    if (sortBy) {
      params.sortBy = sortBy;
    }

    if (desc !== null && desc !== undefined) {
      params.desc = desc;
    }

    if (search && String(search).trim()) {
      params.search = String(search).trim();
    }

    if (etapaNegocio) {
      params.etapaNegocio = etapaNegocio;
    }

    if (motivoCierrePerdido) {
      params.motivoCierrePerdido = motivoCierrePerdido;
    }

    if (startDate) {
      params.startDate = startDate;
    }

    if (endDate) {
      params.endDate = endDate;
    }

    const response = await api.get(`${API_BASE_URL}/NoClients/lost-deals`, {
      params,
      signal,
    });

    return response.data;
  } catch (error) {
    console.error('getNoClientsPaged failed:', error);
    throw error;
  }
};

export const getNoClientsFilters = async ({ signal } = {}) => {
  try {
    const response = await api.get(
      `${API_BASE_URL}/NegociosHubspotSaas/hubspotFilters`,
      { signal }
    );
    return response.data;
  } catch (error) {
    console.error('getNoClientsFilters failed:', error);
    throw error;
  }
};

export const exportNoClientsExcel = async (params = {}, signal) => {
  try {
    const response = await api.get(
      `${API_BASE_URL}/NegociosHubspotSaas/ExportExcel`,
      {
        params,
        responseType: 'blob',
        signal,
      }
    );

    const contentDisposition = response.headers['content-disposition'];
    let filename = `NoClientes_${new Date().toISOString().split('T')[0]}.xlsx`;
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      );
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '');
      }
    }

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    if (window.showSaveFilePicker) {
      try {
        const handle = await window.showSaveFilePicker({
          suggestedName: filename,
          types: [
            {
              description: 'Archivo Excel',
              accept: {
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                  ['.xlsx'],
              },
            },
          ],
        });
        const writable = await handle.createWritable();
        await writable.write(blob);
        await writable.close();
        return;
      } catch (pickerError) {
        if (pickerError.name === 'AbortError') {
          return;
        }
        console.warn(
          'showSaveFilePicker no disponible, usando método alternativo'
        );
      }
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 100);
  } catch (error) {
    console.error('Error descargando Excel:', error);
    throw error;
  }
};
